import axios from '../utils/axios';

/**
 * Manual cleanup - delete old S3 data
 * @param {string} adminId - Admin ID
 * @param {number} retentionMonths - Number of months to retain
 * @returns {Promise} API response
 */
export default function cleanupCronData(adminId, retentionMonths) {
    return axios.post(`/admin/${adminId}/cron/cleanup`, {
        retentionMonths
    });
}
